import React, {useState} from 'react';
import moment from 'moment/moment';
import Trash from '../../SVG/Trash';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import WiFiIcon from '../../SVG/WiFiIcon';
import WebIcon from '../../SVG/WebIcon';
import Dropdown from '../Dropdown/Dropdown';
import Pencil from '../../SVG/Pencil';
import Datepicker from '../Datepicker';
import Checkbox from '../Checkbox';
import {useTranslation} from '../../hooks/useTranslation';
import CommentsIcon from '../../SVG/CommentsIcon';

const LogSheetsRow = ({
  sheet,
  removeLogElement,
  handleSetManualDate,
  manualReason,
  setManualReason,
  subscribtionDates,
  setSubscribtionDates,
  manualError,
  setManualError,
  adjustsDates,
  setAdjustsDates,
}) => {
  const {t} = useTranslation();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const navigate = useNavigate();
  const [showAction, setShowAction] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  const [manualDateModal, setManualDateModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const renderDeleteModal = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p></p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setDeleteModal(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {t('logSheetsRow.deleteModal.title')}
          </div>
          <div className='modal__content-bottom'>
            <button className='close' onClick={() => setDeleteModal(false)}>
              {t('logSheetsRow.deleteModal.close')}
            </button>
            <button
              className='save danger'
              onClick={() => removeLogElement(sheet?.id)}
            >
              {t('logSheetsRow.deleteModal.yes')}
            </button>
          </div>
        </div>
        <div className='modal__bg' onClick={() => setDeleteModal(false)}></div>
      </div>
    );
  };
  const renderSetManualDateModal = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('logSheetsRow.manualDateModal.title')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setManualDateModal(false)}
            />
          </div>
          <div className='modal__content-body'>
            <div style={{width: '100%'}}>
              <p className='trial__modal-title'>
                {t('logSheetsRow.manualDateModal.newInspectionDate')}
              </p>
              <Datepicker
                width={'100%'}
                inputWidth={'100%'}
                minDate={
                  sheet?.min_manual_inspection_date
                    ? moment
                        .utc(sheet?.min_manual_inspection_date)
                        .endOf('day')
                        .toDate()
                    : null
                }
                {...(sheet?.max_manual_inspection_date && {
                  maxDate: moment
                    .min(
                      moment(),
                      moment.utc(sheet.max_manual_inspection_date).endOf('day'),
                    )
                    .toDate(),
                })}
                setValue={e => {
                  setSubscribtionDates(old => ({
                    ...old,
                    start_date: moment(e).format('YYYY-MM-DD'),
                  }));
                  setManualError(prev => ({...prev, date: false}));
                }}
                value={
                  subscribtionDates?.start_date !== 'Invalid date'
                    ? subscribtionDates?.start_date
                    : null
                }
              />
              {manualError.date && (
                <>
                  <span style={{color: 'red'}}>
                    {t('logSheetsRow.errors.dateRequired')}
                  </span>
                </>
              )}
            </div>
            <div style={{width: '100%', marginTop: 20}}>
              <p className='trial__modal-title'>
                {t('logSheetsRow.manualDateModal.reason')}
              </p>
              <textarea
                placeholder={t(
                  'logSheetsRow.manualDateModal.reasonPlaceholder',
                )}
                className='trial__modal-input'
                value={manualReason}
                onChange={e => {
                  setManualReason(e.target.value);
                  setManualError(prev => ({...prev, reason: false}));
                }}
              />
              {manualError.reason && (
                <>
                  <span style={{color: 'red'}}>
                    {t('logSheetsRow.errors.descriptionRequired')}
                  </span>
                </>
              )}
            </div>
            <div style={{width: '100%'}}>
              <Checkbox
                onChange={e => setAdjustsDates(e.target.checked)}
                label={t('logSheetsRow.manualDateModal.changeCompletedDate')}
                id={'Adjusts_dates_for_equipment_management_and_for_reports'}
                checked={adjustsDates}
              />
            </div>
          </div>
          <div className='modal__content-bottom'>
            <button className='close' onClick={() => setManualDateModal(false)}>
              {t('logSheetsRow.manualDateModal.cancel')}
            </button>
            <button
              className='save save'
              onClick={() => {
                const validReason = !manualReason?.length;
                const validDate =
                  subscribtionDates.start_date === 'Invalid date';

                if (validReason || validDate) {
                  setManualError({date: true, reason: validReason});
                  return;
                }

                handleSetManualDate(sheet?.id);
                setManualDateModal(false);
              }}
            >
              {t('logSheetsRow.manualDateModal.save')}
            </button>
          </div>
        </div>
        <div
          className='modal__bg'
          onClick={() => setManualDateModal(false)}
        ></div>
      </div>
    );
  };

  return (
    <>
      <tr
        className={`sheets__table-row ${isExpanded ? 'expanded' : ''}`}
        key={sheet.id}
        onClick={() => {
          if (!isDeleteClicked) {
            navigate(`/inspections/${sheet?.id}`, {
              // state: { sheet: true },
            });
          }
          setIsDeleteClicked(false);
        }}
        onMouseEnter={() => setShowAction(true)}
        onMouseLeave={() => setShowAction(false)}
      >
        <td className='sheets__table-row-linkCell'>
          <a
            className='sheets__table-row-link'
            href={`/inspections/${sheet?.id}`}
            aria-label={sheet?.name}
            tabIndex={-1}
            onClick={e => {
              e.stopPropagation();
              // Let the browser handle modifier/aux clicks natively (open in new tab)
              if (
                e.metaKey ||
                e.ctrlKey ||
                e.shiftKey ||
                e.altKey ||
                e.button !== 0
              ) {
                return;
              }
              e.preventDefault();
              if (!isDeleteClicked) {
                navigate(`/inspections/${sheet?.id}`);
              }
              setIsDeleteClicked(false);
            }}
          />
        </td>
        {deleteModal && renderDeleteModal()}
        <td className='sheets__table-bodyTh'>{sheet.name}</td>

        <td
          className='sheets__table-bodyTh'
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            alignItems: 'flex-start',
            justifyContent: 'center',
          }}
        >
          {sheet?.old_inspection_date && (
            <div
              className={'inspection_date'}
              style={{
                color: '#999999',
                textDecoration: 'line-through',
              }}
            >
              {sheet.old_inspection_date
                ? moment(sheet.old_inspection_date).format('MM/DD/YY')
                : '---'}
            </div>
          )}
          <div
            className={'inspection_date'}
            style={
              sheet?.manual_inspection_date
                ? {
                    color: '#999999',
                    textDecoration: 'line-through',
                  }
                : {}
            }
          >
            {sheet.inspection_date
              ? moment(sheet.inspection_date).format('MM/DD/YY')
              : '---'}
          </div>
          {sheet?.manual_inspection_date && (
            <div className={'inspection_date'}>
              {sheet.manual_inspection_date
                ? moment(sheet.manual_inspection_date).format('MM/DD/YY')
                : '---'}
            </div>
          )}
        </td>
        <td
          className='sheets__table-bodyTh'
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            alignItems: 'flex-start',
            justifyContent: 'center',
          }}
        >
          {sheet?.old_completed_date && (
            <div
              className={'inspection_date'}
              style={{
                color: '#999999',
                textDecoration: 'line-through',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}
            >
              {sheet.old_completed_date
                ? moment(sheet.old_completed_date).format('MM/DD/YY')
                : '---'}
            </div>
          )}
          {sheet.completed_date && (
            <div
              className={'manual_inspection_date'}
              style={{
                marginTop: !sheet.old_completed_date && 0,
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
              }}
            >
              {sheet.completed_date
                ? moment(sheet.completed_date).format('MM/DD/YY')
                : '---'}
            </div>
          )}
        </td>
        <td
          className='sheets__table-bodyTh'
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            alignItems: 'flex-start',
            justifyContent: 'center',
          }}
        >
          <span>{sheet.equipment_title ? sheet.equipment_title : '---'}</span>
          {!!sheet.is_return_to_service && (
            <div className='inspectionTags inspectionTags_RTS'>
              <div className='inspectionTags_RTS_text'>
                {t('logSheetsRow.tags.rts')}
              </div>
            </div>
          )}
        </td>
        <td className='sheets__table-bodyTh'>
          {sheet.facility_title ? sheet.facility_title : '---'}
        </td>
        <td className='sheets__table-bodyTh'>
          <div className='inspections__table-bodyTh_icons'>
            {sheet?.status_icons?.green_nfc_icon ||
            sheet?.status_icons?.web_icon ||
            sheet?.status_icons?.red_nfc_icon ? (
              <>
                {sheet?.status_icons?.green_nfc_icon && (
                  <div className={`inspectionTags inspectionTags_NFC`}>
                    <div className={`inspectionTags_NFC_icon`}>
                      <WiFiIcon width='15' height='15' />
                    </div>
                    <div className={`inspectionTags_NFC_text`}>
                      {t('logSheetsRow.tags.nfc')}
                    </div>
                  </div>
                )}
                {sheet?.status_icons?.web_icon && (
                  <div className={`inspectionTags inspectionTags_WEB`}>
                    <div className={`inspectionTags_WEB_icon`}>
                      <WebIcon width='17' height='17' />
                    </div>
                    <div className={`inspectionTags_WEB_text`}>
                      {t('logSheetsRow.tags.web')}
                    </div>
                  </div>
                )}
                {sheet?.status_icons?.red_nfc_icon && (
                  <div className={`inspectionTags inspectionTags_NO_NFC`}>
                    <div className={`inspectionTags_NO_NFC_icon`}>
                      <WiFiIcon width='15' height='15' color='#DA6767' />
                    </div>
                    <div className={`inspectionTags_NO_NFC_text`}>
                      {t('logSheetsRow.tags.nfc')}
                    </div>
                  </div>
                )}
              </>
            ) : (
              '--- ---'
            )}
          </div>
        </td>
        <td className='sheets__table-bodyTh'>{sheet?.period_label}</td>
        <td
          className={`sheets__table-bodyTh ${sheet.is_complete ? 'completed' : 'not_completed'}`}
        >
          <span>
            {sheet.is_complete
              ? t('logSheetsRow.status.completed')
              : t('logSheetsRow.status.notCompleted')}
          </span>
        </td>
        <td className='sheets__table-bodyTh'>{sheet.submitted_by_name}</td>
        <td
          className={`sheets__table-bodyTh sheets__table-bodyTh--comments ${isExpanded ? 'active' : ''}`}
          style={{position: 'relative', zIndex: 1}}
          onClick={e => {
            e.stopPropagation();
            setIsExpanded(prev => !prev);
          }}
        >
          {sheet.manual_inspection_date_description ? (
            <span
              className={`comments-icon-wrap ${isExpanded ? 'active' : ''}`}
            >
              <CommentsIcon />
            </span>
          ) : (
            '-'
          )}
        </td>
        {(userInfo?.is_global || userInfo?.is_corporate) && (
          <td
            className={`sheets__table-delete ${showAction ? 'active' : ''}`}
            id={'sheet-delete'}
          >
            <Dropdown
              elements={[
                userInfo?.is_global
                  ? {
                      label: t('logSheetsRow.actions.delete'),
                      icon: <Trash color={'#DA6767'} />,
                      onClick: () => {
                        setIsDeleteClicked(true);
                        setDeleteModal(true);
                        setSubscribtionDates({});
                      },
                      labelColor: '#DA6767',
                    }
                  : null,
                sheet.period !== 'daily' &&
                sheet.period !== 'other' &&
                sheet.period !== 'fuel' &&
                sheet.is_complete
                  ? {
                      label: t('logSheetsRow.actions.setManualDate'),
                      icon: <Pencil color={'#27323C'} />,
                      onClick: () => {
                        setManualDateModal(true);
                        setSubscribtionDates({
                          start_date: moment(
                            sheet.manual_inspection_date,
                          ).format('YYYY-MM-DD'),
                        });
                        setManualReason(
                          sheet.manual_inspection_date_description,
                        );
                      },
                      labelColor: '#27323C',
                    }
                  : null,
              ]}
            />
          </td>
        )}
      </tr>
      {isExpanded && (
        <tr className='sheets__table-comments-panel-row'>
          <td colSpan={11} className='sheets__table-comments-panel-cell'>
            <div className='sheets__table-comments-panel'>
              <button
                className='sheets__table-comments-panel__close'
                onClick={e => {
                  e.stopPropagation();
                  setIsExpanded(false);
                }}
              >
                <img src='/assets/icons/close.svg' alt='close' />
              </button>
              {sheet?.manual_inspection_date_description ? (
                (() => {
                  const name = sheet?.submitted_by_name ?? '';
                  const initials = name
                    .split(' ')
                    .filter(Boolean)
                    .slice(0, 2)
                    .map(w => w[0].toUpperCase())
                    .join('');
                  return (
                    <div className='sheets__table-comments-panel__item'>
                      <div className='sheets__table-comments-panel__avatar'>
                        {sheet?.submitted_user?.avatar ? (
                          <img src={sheet.submitted_user.avatar} alt={name} />
                        ) : (
                          <span>{initials}</span>
                        )}
                      </div>
                      <div className='sheets__table-comments-panel__body'>
                        <div className='sheets__table-comments-panel__meta'>
                          <span className='sheets__table-comments-panel__name'>
                            {name}
                          </span>
                          <span className='sheets__table-comments-panel__date'>
                            {sheet?.submission_date
                              ? moment(sheet.submission_date).format(
                                  'MMM D, YYYY · h:mm A',
                                )
                              : '---'}
                          </span>
                        </div>
                        <p className='sheets__table-comments-panel__text'>
                          {sheet.manual_inspection_date_description}
                        </p>
                      </div>
                    </div>
                  );
                })()
              ) : (
                <div className='sheets__table-comments-panel__empty'>
                  {t('logSheetsRow.comments.noComments')}
                </div>
              )}
            </div>
          </td>
        </tr>
      )}
      {manualDateModal && renderSetManualDateModal()}
    </>
  );
};

export default LogSheetsRow;
